import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import attachmentApi, {
  AttachmentCreateRequest,
  AttachmentOwnerType
} from '../services/attachmentApi'

export const attachmentQueryKeys = {
  all: ['attachments'] as const,
  owner: (ownerType: AttachmentOwnerType, ownerId: number) =>
    [...attachmentQueryKeys.all, ownerType, ownerId] as const
}

export const useAttachments = (ownerType?: AttachmentOwnerType, ownerId?: number) => {
  return useQuery({
    queryKey: attachmentQueryKeys.owner(ownerType || 'sample', ownerId || 0),
    queryFn: () => attachmentApi.getByOwner(ownerType || 'sample', ownerId || 0),
    enabled: !!ownerType && !!ownerId,
    staleTime: 2 * 60 * 1000
  })
}

export const useCreateAttachment = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (request: AttachmentCreateRequest) => attachmentApi.create(request),
    onSuccess: (attachment) => {
      queryClient.invalidateQueries({
        queryKey: attachmentQueryKeys.owner(attachment.ownerType, attachment.ownerId)
      })
    }
  })
}
